import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { useRef } from 'react';

interface ActionMenuProps {
    rowData: any;
    hasPermission: (pageName: string, featureName?: string) => boolean;
    openEdit: (rowData: any, type: 'form' | 'aminity') => void;
    toggleSection: (id: number, type: 'contact' | 'roomType' | 'roomPrice') => void;
    confirmDelete: (rowData: any) => void;
}

export const ActionMenu: React.FC<ActionMenuProps> = ({ rowData, hasPermission, openEdit, toggleSection, confirmDelete }) => {
    const menuRef = useRef<Menu>(null);

    const items = [
        hasPermission("Hotel", "Edit") && {
            label: 'Edit Hotel',
            icon: 'pi pi-pencil',
            command: () => openEdit(rowData, 'form'),
        },
        hasPermission("Hotel", "Contact") && {
            label: 'Contact',
            icon: 'pi pi-user',
            command: () => toggleSection(rowData.id, 'contact'),
        },
        hasPermission("Hotel", "RoomType") && {
            label: 'Room Type',
            icon: 'pi pi-slack',
            command: () => toggleSection(rowData.id, 'roomType'),
        },
        hasPermission("Hotel", "RoomPrice") && {
            label: 'Room Price',
            icon: 'pi pi-money-bill',
            command: () => toggleSection(rowData.id, 'roomPrice'),
        },
        hasPermission("Hotel", "Aminity") && {
            label: 'Aminities',
            icon: 'pi pi-box',
            command: () => openEdit(rowData, 'aminity'),
        },
        hasPermission("Hotel", "Remove") && {
            label: 'Delete',
            icon: 'pi pi-trash',
            className: 'text-red-600',
            command: () => confirmDelete(rowData),
        },
    ].filter(Boolean);

    return (
        <div className="actions-dropdown">
            <Menu model={items as any[]} popup ref={menuRef} />
            <Button
                icon="pi pi-ellipsis-v"
                className="p-button-text p-button-sm p-0"
                onClick={(e) => menuRef.current?.toggle(e)}
            />
        </div>
    );
};
